import { z } from 'zod';

export const userRoleSchema = z.enum(['admin', 'financeiro', 'comercial', 'suporte', 'dev']);
export type UserRoleSchema = z.infer<typeof userRoleSchema>;

export const userSchema = z.object({
  id: z.string().uuid(),
  auth_id: z.string(),
  email: z.string().email(),
  name: z.string().min(1),
  picture_url: z.string().url().nullable(),
  role: userRoleSchema,
  is_active: z.boolean(),
  last_login_at: z.string().datetime().nullable(),
  created_at: z.string().datetime(),
  version: z.number().int().positive(),
});
export type User = z.infer<typeof userSchema>;

export const updateUserDtoSchema = z.object({
  role: userRoleSchema.optional(),
  is_active: z.boolean().optional(),
  version: z.number().int().positive(),
});
export type UpdateUserDto = z.infer<typeof updateUserDtoSchema>;

// -----------------------------------------------------------------------------
// USER PICKER (Story 11.4) — shape mínimo pro picker de responsável.
// READ-ONLY. Expõe SÓ id/name/role (sem email/last_login/dados sensíveis — NFR-14).
// Usado em GET /api/users (lista usuários ativos) e nos selects de responsável
// (LeadForm, DealForm). Fonte única back+front.
// -----------------------------------------------------------------------------

export const userPickerSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1),
  role: userRoleSchema,
});
export type UserPicker = z.infer<typeof userPickerSchema>;

// JWT payload do auth.owlflow — assina { userId, email, appId, role }
export const authJwtPayloadSchema = z.object({
  userId: z.string(),
  email: z.string().email(),
  appId: z.string().optional(),
  role: z.string().optional(),
  iat: z.number(),
  exp: z.number(),
});
export type AuthJwtPayload = z.infer<typeof authJwtPayloadSchema>;
